module.exports = __webpack_public_path__ + "img/icon_design_active.d1f00236.svg";